export const maxLengthError = error => ({ max }) => (
  error.replace('{0}', max)
);
